import React from 'react';

import { connect } from 'react-redux';

import { LegacyAnalyticsInterface } from '@nerdwallet/calculator-onboarding-modal';

import cityChange from '../../../../lib/actions/cityChange';
import { validationsSelector } from '../../../../lib/selectors';
import {
  manualInputsSelector,
  inputsSelector,
} from '../../../../lib/selectors/mortgage-calculator';
import {
  MortgageInput,
  INPUT_TRACKING_TYPES,
  debouncedTrackOnChange,
  BedrockInterface,
} from '../../../../lib/utils';
import LocationAutoComplete from '../../../location-autocomplete/location-autocomplete';

const PurchaseLocationInput: React.FC<MortgageInput> = ({
  manualInputs,
  inputs,
  dispatch,
  label,
  analytics,
}) => {
  const analyticsEnabled = analytics && analytics?.enabled;
  const legacyAnalytics =
    analyticsEnabled && analytics?.payload?.legacy?.formName;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (value) => {
    const { city, zip } = value;
    const trackingValue = `${city}${zip ? ` (${zip})` : ''}`;

    let legacy: LegacyAnalyticsInterface;
    if (legacyAnalytics) {
      const legacyProps = analytics?.payload?.legacy;
      legacy = {
        ...legacyProps,
        fieldName: 'LocationAutoComplete',
        inputType: INPUT_TRACKING_TYPES.TEXT,
      };
    }

    let bedrock: BedrockInterface;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_s',
      };
    }

    debouncedTrackOnChange({
      legacy,
      bedrock,
      validation: { valid: true },
      value: trackingValue,
    });

    dispatch(cityChange(value, 'purchaseAddress'));
  };

  return (
    <LocationAutoComplete
      data={manualInputs}
      enableTracking={false}
      label={label}
      key="mortgage-location-autocomplete"
      onChange={onInputChange}
      placeholder={`${inputs.purchaseAddress.city}, ${inputs.purchaseAddress.state}`}
      smallOnMobile={false}
      trackingFormName="onboarding"
    />
  );
};

const mapStateToProps = (state) => ({
  manualInputs: manualInputsSelector(state),
  inputs: inputsSelector(state),
  validations: validationsSelector(state),
});

export default connect(mapStateToProps)(PurchaseLocationInput);
